(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name dailyOpsReport.controller:DailyOpsReportCtrl
   *
   * @description
   *
   */
  angular
    .module('dailyOpsReport')
    .controller('DailyOpsReportCtrl', DailyOpsReportCtrl);

  function DailyOpsReportCtrl(CommonMasterData,$sce, CommonLogicService, MessageService) {
    var vm = this;
    vm.ctrlName = 'DailyOpsReportCtrl';
  //report types
    vm.reportTypes = {
    		MAY_FLY : 'mayfly',
    		AC_ROTATION : 'acrotation',
    		OTP : 'otp'
    }

    vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				reportType : null,
        carriers : []
			},
			masterList : {
				fromTimeInvalid : false,
        carriers : [],
        defaultCarrier : null
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchDailyOPSReport(params);
		};

		// when change field in search
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
		};

		function setDateValidationFlags() {
			//if from date invalid
			if(isDateFormatInvalid(vm.model.searchCriteria.fromDate)){
				vm.model.masterList.fromDateFormatInvalid = true;
			}else{
				vm.model.masterList.fromDateFormatInvalid = false;
			}
		}

		//validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// search daily ops report
		function searchDailyOPSReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var type = getReportType(param.reportType);
				var rptDesign = "";
				switch (type){
					case vm.reportTypes.OTP :
						rptDesign = "dailyops_otp_report.rptdesign";
						break;
					case vm.reportTypes.AC_ROTATION :
						rptDesign = "ac_rotation_report.rptdesign";
						break;
					default :
						rptDesign = "may_fly_report.rptdesign";
						break;
				}

				var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["reportDate"] = param.fromDate;
			searchParamMap["reportMode"] = getReportType(param.reportType);
      searchParamMap["carrierCodes"] = getSelectedCarrierCodes(param.carriers);
      searchParamMap["referrer"] = window.location.origin;
			return searchParamMap;
		}

		function getReportType(reportType){
			if(reportType === null ){
				return vm.reportTypes.MAY_FLY;
			}else if(!reportType){
				return vm.reportTypes.AC_ROTATION;
			}else{
				return vm.reportTypes.OTP;
			}
		}

    function getSelectedCarrierCodes(carrierCodes){
      var carriers = [];
      if(carrierCodes.length > 0) {
        angular.forEach(carrierCodes, function (carrier) {
          carriers.push(carrier.code);
        })
      } else {
        carriers.push(vm.model.masterList.defaultCarrier);
      }
      return carriers;
    }

		function isValidSearchParams(params) {
			setDateValidationFlags();
			if(!!vm.model.searchCriteria.fromDate && !vm.model.masterList.fromDateFormatInvalid){
				return true;
			}
			return false;
		}

    (function() {
      // load accepting carriers list
      CommonMasterData.searchCarriers(function (response) {
          for(var index in response.hubCodes) {
            vm.model.masterList.carriers.push({"code":response.hubCodes[index],"name":response.hubCodes[index]});
          }
          vm.model.masterList.defaultCarrier = response.clientCode;
        }, function (error) {
          MessageService.error(error);
        }
      );
    })();
	}
}());
